"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Teams API
 * # Summary  This API is for managing teams and their members.  Teams can be used as a sharing target for specific assets, and can have asset ownership transferred to them.  The teams feature is turned on by either the `strict_permissions` or `enable_teams` feature flags. If both of those feature flags are off, this API will always return a 404.  On any domain, teams can be managed in the UI by going to `/admin/teams`.  # Team Roles  Within a team, a user has a \"team role\".  This team role will either be `owner` or `member`.  Team members with the `owner` role can add/remove other team members, and promote other team members to the `owner` role. There can be multiple members with the `owner` role on a team.  At least one member *must* have the `owner` role, and the API will prevent demoting or removing the final `owner` from a team.  Members with the `member` and the `owner` team roles will both get permissions for any assets that are shared to or owner by the team.  # Changelog  ## 1.1.1  Add missing `title` of `TeamEligibleForDeletionResponse` to [`eligibleForDeletion`](#operation/eligibleForDeletion) operation.  ## 1.1.0  Add [`eligibleForDeletion`](#operation/eligibleForDeletion) operation.  ## 1.0.5  Documentation updates.  ## 1.0.4  Add `email` to `CreateOrUpdateTeamRequestParameters`.  ## 1.0.3  Return `204` (No Content) when deleting team members.  ## 1.0.2  Remove support for ES6 in `typescript-fetch` clients. This was breaking in Internet Explorer 11.  ## 1.0.1  Add missing `description` field to `Team` schema  ## 1.0.0  Initial specification.
 *
 * The version of the OpenAPI document: 1.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var TeamsApi = /** @class */ (function (_super) {
    __extends(TeamsApi, _super);
    function TeamsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new `Team` on this domain.
     * Create a Team
     */
    TeamsApi.prototype.createTeamRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/api/teams",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateOrUpdateTeamRequestParametersToJSON(requestParameters.createOrUpdateTeamRequestParameters),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.TeamFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new `Team` on this domain.
     * Create a Team
     */
    TeamsApi.prototype.createTeam = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createTeamRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a specific `Team` on the domain.
     * Delete a Team
     */
    TeamsApi.prototype.deleteTeamRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.teamId === null || requestParameters.teamId === undefined) {
                            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling deleteTeam.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/teams/{team-id}".replace("{" + "team-id" + "}", encodeURIComponent(String(requestParameters.teamId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete a specific `Team` on the domain.
     * Delete a Team
     */
    TeamsApi.prototype.deleteTeam = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteTeamRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This will tell you whether or not a team is eligible for deletion, along with reasons that it cannot be deleted.
     * Check Whether Team is Eligible for Deletion
     */
    TeamsApi.prototype.eligibleForDeletionRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.teamId === null || requestParameters.teamId === undefined) {
                            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling eligibleForDeletion.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/teams/{team-id}/eligibleForDeletion".replace("{" + "team-id" + "}", encodeURIComponent(String(requestParameters.teamId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.TeamEligibleForDeletionResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This will tell you whether or not a team is eligible for deletion, along with reasons that it cannot be deleted.
     * Check Whether Team is Eligible for Deletion
     */
    TeamsApi.prototype.eligibleForDeletion = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.eligibleForDeletionRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Depending on the current user\'s domain rights, this will return different things.  If the current user has the `manage_teams` domain right, this will return a list of _all_ teams on the domain.  If the current user _does not_ have the `manage_tams` domain right, this will only return teams the the current user is a member of.
     * Get All Teams
     */
    TeamsApi.prototype.getAllTeamsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.limit === null || requestParameters.limit === undefined) {
                            throw new runtime.RequiredError('limit', 'Required parameter requestParameters.limit was null or undefined when calling getAllTeams.');
                        }
                        if (requestParameters.page === null || requestParameters.page === undefined) {
                            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getAllTeams.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/teams",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.TeamFromJSON); })];
                }
            });
        });
    };
    /**
     * Depending on the current user\'s domain rights, this will return different things.  If the current user has the `manage_teams` domain right, this will return a list of _all_ teams on the domain.  If the current user _does not_ have the `manage_tams` domain right, this will only return teams the the current user is a member of.
     * Get All Teams
     */
    TeamsApi.prototype.getAllTeams = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllTeamsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a specific `Team` for the domain.
     * Get a Team
     */
    TeamsApi.prototype.getTeamRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.teamId === null || requestParameters.teamId === undefined) {
                            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling getTeam.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/teams/{team-id}".replace("{" + "team-id" + "}", encodeURIComponent(String(requestParameters.teamId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.TeamFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a specific `Team` for the domain.
     * Get a Team
     */
    TeamsApi.prototype.getTeam = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTeamRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update a specific `Team` object for the domain.
     * Update a Team
     */
    TeamsApi.prototype.updateTeamRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.teamId === null || requestParameters.teamId === undefined) {
                            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling updateTeam.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/api/teams/{team-id}".replace("{" + "team-id" + "}", encodeURIComponent(String(requestParameters.teamId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateOrUpdateTeamRequestParametersToJSON(requestParameters.createOrUpdateTeamRequestParameters),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.TeamFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update a specific `Team` object for the domain.
     * Update a Team
     */
    TeamsApi.prototype.updateTeam = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateTeamRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return TeamsApi;
}(runtime.BaseAPI));
exports.TeamsApi = TeamsApi;
